"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var RatingStarCircle = function RatingStarCircle(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 20 20",
    height: "20",
    width: "20"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(0.8333333333333334,0,0,0.8333333333333334,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12C23.993,5.376,18.624,0.007,12,0z M18.216,10.376l-2.788,2.485 c-0.161,0.144-0.212,0.374-0.126,0.572l1.629,3.749c0.108,0.254-0.011,0.548-0.265,0.656c-0.141,0.06-0.301,0.052-0.435-0.022 l-3.982-2.242c-0.152-0.086-0.339-0.086-0.491,0l-3.985,2.242c-0.242,0.132-0.546,0.043-0.678-0.199 c-0.073-0.134-0.081-0.294-0.022-0.435L8.7,13.433c0.086-0.198,0.035-0.428-0.126-0.572l-2.79-2.485 C5.576,10.194,5.556,9.878,5.738,9.67C5.833,9.561,5.971,9.499,6.116,9.5h3.31c0.199,0.001,0.38-0.117,0.46-0.3l1.655-3.84 c0.11-0.253,0.404-0.37,0.657-0.261c0.117,0.051,0.21,0.144,0.261,0.261l1.655,3.84c0.08,0.183,0.261,0.301,0.46,0.3h3.31 c0.276,0.001,0.5,0.225,0.499,0.501c0,0.142-0.061,0.277-0.167,0.372L18.216,10.376z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
RatingStarCircle.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
RatingStarCircle.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = RatingStarCircle;